import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomysoreootycab() {



    const cardData = {

keyword: "Pune to Mysore Ooty Cab Package",

headingDescription:
    "Rising Cab Service offers comfortable and affordable Pune to Mysore Ooty Cab Package services for families, couples, and groups planning a long-distance South India tour. Our packages include well-maintained Sedan, SUV, Innova Crysta, and Tempo Traveller vehicles with experienced drivers for a safe and smooth journey. We provide flexible itineraries covering Mysore heritage sites and Ooty hill station attractions with one-way and round-trip options. With 24/7 support, transparent pricing, and door-to-door pickup, Rising Cab Service ensures a hassle-free travel experience for your holiday.",

topPlaces: [
    {
        title: "Mysore Palace",
        description:
            "Mysore Palace is one of India’s most magnificent royal residences, known for its grand Indo-Saracenic architecture, illuminated evenings, and rich history of the Wodeyar dynasty. The palace attracts millions of visitors for its stunning halls, intricate carvings, and cultural significance."
    },
    {
        title: "Chamundi Hills",
        description:
            "Chamundi Hills is a famous spiritual and sightseeing destination in Mysore, home to the Chamundeshwari Temple. Visitors enjoy panoramic views of the city along with the giant Nandi statue and scenic winding roads leading to the hilltop."
    },
    {
        title: "Brindavan Gardens",
        description:
            "Brindavan Gardens, located near Krishnarajasagar Dam, is famous for its symmetrical layout, musical fountain show, and beautifully lit terraces. It is one of the most popular evening attractions in Mysore for families and tourists."
    },
    {
        title: "St. Philomena’s Church",
        description:
            "St. Philomena’s Church is one of the tallest churches in Asia, known for its neo-gothic architecture, stained glass windows, and peaceful ambiance. It is a major landmark reflecting Mysore’s cultural diversity."
    },
    {
        title: "Mysore Zoo",
        description:
            "Mysore Zoo is one of the oldest and most well-maintained zoological parks in India, housing a wide variety of animals and birds. It is a favorite attraction for families and wildlife enthusiasts visiting Mysore."
    },
    {
        title: "Ooty Lake",
        description:
            "Ooty Lake is a scenic artificial lake surrounded by eucalyptus trees and hills, offering boating and relaxing views. It is one of the most visited attractions in Ooty and a perfect spot for leisure activities."
    },
    {
        title: "Government Botanical Garden Ooty",
        description:
            "The Botanical Garden in Ooty is a beautifully maintained garden spread across terraced landscapes, featuring exotic plants, rare trees, and colorful flower beds. It is a must-visit for nature lovers and photographers."
    },
    {
        title: "Doddabetta Peak",
        description:
            "Doddabetta Peak is the highest point in the Nilgiri Hills, offering breathtaking panoramic views of Ooty and surrounding valleys. It is a popular trekking and sightseeing destination for adventure seekers."
    },
    {
        title: "Rose Garden Ooty",
        description:
            "The Rose Garden in Ooty is home to thousands of varieties of roses arranged across terraced slopes. It is one of the largest rose gardens in India and a major attraction for tourists."
    },
    {
        title: "Pykara Waterfalls",
        description:
            "Pykara Waterfalls is a stunning natural attraction near Ooty, known for its cascading water surrounded by lush greenery. It is a peaceful spot ideal for photography and enjoying the beauty of the Nilgiris."
    }
],



services: [
    {
        name: "Pune to Mysore Ooty Cab Package",
        description:
            "Rising Cab Service offers Pune to Mysore Ooty Cab Package for travelers seeking a comfortable and scenic long-distance road trip covering Mysore and Ooty. Our packages include well-maintained AC vehicles, experienced drivers, and flexible itineraries designed for families, couples, and tourist groups. Enjoy a smooth journey with sightseeing stops, hotel assistance, and customizable travel plans for a memorable South India tour experience."
    },
    {
        name: "Pune to Mysore Ooty Tour Package",
        description:
            "Book Pune to Mysore Ooty Tour Package with Rising Cab Service for a complete travel experience covering Mysore Palace, Brindavan Gardens, Ooty Lake, Doddabetta Peak, and more. We provide comfortable cab options, professional drivers, and well-planned routes to ensure a safe and enjoyable holiday for families, friends, and couples."
    },
    {
        name: "Pune to Mysore Ooty Taxi Package",
        description:
            "Rising Cab Service provides Pune to Mysore Ooty Taxi Package designed for long-distance road trips with maximum comfort and safety. Our service includes clean AC cabs, experienced highway drivers, and flexible travel schedules for sightseeing across Mysore and Ooty at your convenience."
    },
    {
        name: "Pune to Mysore Ooty Car Rentals",
        description:
            "Our Pune to Mysore Ooty Car Rentals service offers reliable self-driven or chauffeur-driven cars for long vacation trips. Rising Cab Service ensures well-maintained vehicles, transparent pricing, and flexible booking options suitable for family vacations, honeymoon trips, and group tours."
    },
    {
        name: "Pune to Mysore Ooty Cab Service",
        description:
            "Rising Cab Service provides Pune to Mysore Ooty Cab Service for safe and comfortable interstate travel. Our service is ideal for tourists and families looking for a hassle-free road trip experience with professional drivers and customizable tour plans."
    },
    {
        name: "Pune to Ooty Mysore Tour by Cab",
        description:
            "Book Pune to Ooty Mysore Tour by Cab with Rising Cab Service for a scenic journey across two of South India’s most beautiful destinations. Our packages include sightseeing, hotel stops, and flexible itineraries for a relaxed and enjoyable vacation."
    },
    {
        name: "Mysore Ooty Package from Pune",
        description:
            "Rising Cab Service offers Mysore Ooty Package from Pune for families, couples, and groups seeking a well-planned holiday. Our packages include comfortable transportation, sightseeing coverage, and flexible travel options for a memorable trip experience."
    },
    {
        name: "Pune to Mysore Ooty Road Trip Package",
        description:
            "Our Pune to Mysore Ooty Road Trip Package is perfect for travelers who enjoy long scenic drives. Rising Cab Service provides experienced drivers, comfortable AC vehicles, and customizable stops along the route for a relaxed and enjoyable journey."
    },
    {
        name: "Pune to Mysore Ooty Holiday Package",
        description:
            "Rising Cab Service offers Pune to Mysore Ooty Holiday Package with complete travel solutions including transportation, sightseeing, and flexible itineraries. Ideal for families, couples, and groups planning a peaceful vacation in South India."
    },
    {
        name: "Pune to Ooty Cab Package",
        description:
            "Book Pune to Ooty Cab Package with Rising Cab Service for a comfortable hill station trip. Our service includes safe driving, clean vehicles, and flexible travel plans for sightseeing in Ooty and nearby attractions."
    },
    {
        name: "Mysore Ooty Tour Package from Pune",
        description:
            "Rising Cab Service provides Mysore Ooty Tour Package from Pune with complete travel arrangements for a smooth and enjoyable vacation. Explore Mysore and Ooty with professional drivers and well-planned sightseeing schedules."
    },
    {
        name: "Pune Mysore Ooty Family Tour Package",
        description:
            "Our Pune Mysore Ooty Family Tour Package is designed for comfortable family travel with spacious vehicles, safe driving, and customized sightseeing options across Mysore and Ooty tourist attractions."
    },
    {
        name: "Pune Mysore Ooty Honeymoon Package",
        description:
            "Rising Cab Service offers Pune Mysore Ooty Honeymoon Package for couples seeking a romantic getaway. Enjoy scenic hill stations, peaceful travel, and comfortable cab services for a memorable honeymoon experience."
    },
    {
        name: "Pune to Mysore Ooty Sightseeing Package",
        description:
            "Book Pune to Mysore Ooty Sightseeing Package with Rising Cab Service for a complete tour covering waterfalls, gardens, palaces, lakes, and hill viewpoints in Mysore and Ooty."
    },
    {
        name: "Pune to Mysore Ooty Vacation Package",
        description:
            "Rising Cab Service provides Pune to Mysore Ooty Vacation Package for travelers looking for a relaxing holiday with comfortable transportation, sightseeing tours, and flexible travel plans."
    },
    {
        name: "Pune to Mysore Ooty Trip Cost",
        description:
            "Get the best Pune to Mysore Ooty Trip Cost with Rising Cab Service offering transparent pricing for cab packages, sightseeing tours, and customized travel plans based on your budget and vehicle preference."
    },
    {
        name: "Pune to Mysore Ooty Travel Package",
        description:
            "Rising Cab Service offers Pune to Mysore Ooty Travel Package with complete road trip solutions including cab booking, sightseeing, and flexible itinerary planning for a smooth journey."
    },
    {
        name: "Budget Mysore Ooty Package from Pune",
        description:
            "Book Budget Mysore Ooty Package from Pune with Rising Cab Service for affordable travel without compromising comfort. We offer economical cab options with safe and reliable travel arrangements."
    },
    {
        name: "Luxury Mysore Ooty Tour Package",
        description:
            "Rising Cab Service provides Luxury Mysore Ooty Tour Package with premium vehicles, top-class comfort, and personalized travel services for a luxurious vacation experience."
    },
    {
        name: "Pune to Mysore Ooty Weekend Tour",
        description:
            "Our Pune to Mysore Ooty Weekend Tour is ideal for short vacations with well-planned itineraries, comfortable cab services, and scenic travel routes for a refreshing weekend getaway."
    },
    {
        name: "Innova Crysta Pune to Mysore Ooty Package",
        description:
            "Rising Cab Service offers Innova Crysta Pune to Mysore Ooty Package for premium comfort, spacious seating, and smooth long-distance travel ideal for families and groups."
    },
    {
        name: "Ertiga Cab Pune to Mysore Ooty",
        description:
            "Book Ertiga Cab Pune to Mysore Ooty with Rising Cab Service for a comfortable and budget-friendly family trip with reliable drivers and well-maintained vehicles."
    }
],

tableData: [
    ["Pune to Mysore Ooty Cab Package", "Pune to Mysore Ooty Tour Package"],
    ["Pune to Mysore Ooty Taxi Package", "Pune to Mysore Ooty Car Rentals"],
    ["Pune to Mysore Ooty Cab Service", "Pune to Ooty Mysore Tour by Cab"],
    ["Mysore Ooty Package from Pune", "Pune to Mysore Ooty Road Trip Package"],
    ["Pune to Mysore Ooty Holiday Package", "Pune to Ooty Cab Package"],
    ["Mysore Ooty Tour Package from Pune", "Pune Mysore Ooty Family Tour Package"],
    ["Pune Mysore Ooty Honeymoon Package", "Pune to Mysore Ooty Sightseeing Package"],
    ["Pune to Mysore Ooty Vacation Package", "Pune to Mysore Ooty Trip Cost"],
    ["Pune to Mysore Ooty Travel Package", "Budget Mysore Ooty Package from Pune"],
    ["Luxury Mysore Ooty Tour Package", "Pune to Mysore Ooty Weekend Tour"],
    ["Innova Crysta Pune to Mysore Ooty Package", "Ertiga Cab Pune to Mysore Ooty"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Mysore Ooty Cab Packages",
        WhyChoosedescription: "Rising Cab Service offers well-planned Pune to Mysore Ooty Cab Packages for families, couples, friends, and groups seeking a memorable South India holiday."
    },
    {
        WhyChooseheading: "Cover Popular Tourist Attractions",
        WhyChoosedescription: "Our package allows travelers to explore Mysore Palace, Chamundi Hills, Brindavan Gardens, Ooty Lake, Botanical Garden, Doddabetta Peak, and other famous attractions."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "We provide Sedan cars, Ertiga, Innova Crysta, Tempo Travellers, and luxury vehicles suitable for every travel requirement and group size."
    },
    {
        WhyChooseheading: "Customized Tour Itineraries",
        WhyChoosedescription: "Rising Cab Service offers flexible travel plans that can be customized according to your sightseeing preferences, travel duration, and budget."
    },
    {
        WhyChooseheading: "Experienced Drivers for Long Tours",
        WhyChoosedescription: "Our professional drivers are experienced in handling long-distance routes and ensure a safe, smooth, and enjoyable travel experience."
    },
    {
        WhyChooseheading: "Affordable Multi-Day Travel Packages",
        WhyChoosedescription: "We provide budget-friendly Pune to Mysore Ooty tour packages with transparent pricing and complete travel convenience."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Convenient pickup services are available from Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Viman Nagar, Pimpri Chinchwad, Pune Airport, and nearby areas."
    },
    {
        WhyChooseheading: "Perfect for Family Vacations and Honeymoon Trips",
        WhyChoosedescription: "Our Pune to Mysore Ooty Cab Package is ideal for family holidays, honeymoon tours, group vacations, educational trips, and corporate outings."
    }
]
};

const faqData = [
    {
        question: "What is included in the Pune to Mysore Ooty Cab Package?",
        answer: "The package includes cab transportation, sightseeing assistance, pickup and drop services, and customized travel planning."
    },
    {
        question: "Which attractions are covered in Mysore and Ooty?",
        answer: "Popular attractions include Mysore Palace, Chamundi Hills, Brindavan Gardens, Ooty Lake, Botanical Garden, Doddabetta Peak, Rose Garden, and Tea Estates."
    },
    {
        question: "Can I customize my Mysore Ooty tour itinerary?",
        answer: "Yes, Rising Cab Service provides customized itineraries based on your travel preferences and duration."
    },
    {
        question: "Which vehicles are available for the tour?",
        answer: "We offer Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles."
    },
    {
        question: "How many days are required for a Mysore Ooty tour from Pune?",
        answer: "Most travelers choose a 4 to 6-day itinerary depending on sightseeing plans and travel preferences."
    },
    {
        question: "Is the package suitable for families?",
        answer: "Yes, the Pune to Mysore Ooty Cab Package is ideal for families, children, senior citizens, and group travelers."
    },
    {
        question: "Do you provide hotel booking assistance?",
        answer: "Yes, hotel arrangements can be suggested or included as per customer requirements."
    },
    {
        question: "Are the drivers experienced for South India routes?",
        answer: "Yes, our drivers are experienced in long-distance interstate travel and major tourist destinations."
    },
    {
        question: "Can I add additional sightseeing destinations to the package?",
        answer: "Yes, nearby destinations can be included through customized travel planning."
    },
    {
        question: "How can I book a Pune to Mysore Ooty Cab Package?",
        answer: "You can book your package through phone, WhatsApp, or online booking with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Akash Patwardhan",
        feedback:
            "Our Mysore and Ooty vacation was perfectly managed by Rising Cab Service. The vehicle was comfortable, the driver was professional, and the entire trip was enjoyable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Priya Kulkarni",
        feedback:
            "We traveled with family and had an amazing experience exploring Mysore and Ooty. The cab was well-maintained, and the journey remained comfortable throughout the tour.",
        rating: 5
    }
];
















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Mysore Ooty Cab Package",
"image": "https://www.risingcabservice.com/assets/images/pune-to-mysore-ooty-cab-package.jpg",
"description": "Book Pune to Mysore Ooty Cab Package with Rising Cab Service for comfortable long-distance tours, holiday trips, and South India travel. Enjoy safe, reliable, and affordable cab packages for Mysore and Ooty sightseeing.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-mysore-ooty-cab-package"
}
};







    return (
        <div>


<Helmet>
  <title>Pune to Mysore Ooty Cab Package | South India Tour | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Mysore Ooty Cab Package for South India travel, holiday trips, and sightseeing tours. Comfortable long-distance cab service with experienced drivers and flexible tour packages."
/>

<meta
 name="keywords"
 content="Pune to Mysore Ooty Cab Package, Pune to Mysore Ooty Tour Package, Pune to Mysore Ooty Taxi Package, Pune to Mysore Ooty Car Rentals, Pune to Mysore Ooty Cab Service, Pune to Ooty Mysore Tour by Cab, Mysore Ooty Package from Pune, Pune to Mysore Ooty Road Trip Package, Pune to Mysore Ooty Holiday Package"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomysoreootycab;